import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleFormatService } from 'src/core/services';
import { LanguageStore } from 'src/core/stores';

@Pipe({
  name: 'localeNumber',
  standalone: true,
  pure: false,
})
export class LocaleNumberPipe implements PipeTransform {
  private readonly localeFormatService = inject(LocaleFormatService);
  private readonly languageStore = inject(LanguageStore);

  transform(
    value: number | null | undefined,
    numberFormatOptions: Intl.NumberFormatOptions = {},
  ): string {
    void this.languageStore.locale();
    return this.localeFormatService.formatNumber(value, numberFormatOptions);
  }
}
